import React, { Component } from 'react';
import './Inspectr.css';
import { Link } from 'react-router-dom';
import Header from '../header/Header';
import Footer from '../footer/Footer';
const watsonForm = require('../../assets/img/form.png');
const watsonRetail = require('../../assets/img/retail.png');
const watsonSound = require('../../assets/img/sound.png');
const watsonTruck = require('../../assets/img/truck.png');
const watsonAudio = require('../../assets/img/audio.png');
const watsonCar = require('../../assets/img/car.png');
const watsonHighway = require('../../assets/img/highway.png');
const watsonTrain = require('../../assets/img/train.png');
const watsonBolt = require('../../assets/img/bolt.png');
const watsonSpace = require('../../assets/img/space.png');
const watsonTraffic = require('../../assets/img/Traffic.png');
const watsonPumps = require('../../assets/img/Pumps.png');
const watsonGeology = require('../../assets/img/geology.png');
const watsonStamp = require('../../assets/img/stamp.png');
const watsonAed = require('../../assets/img/aed.png');
const watsonEnergy = require('../../assets/img/energy.png');
const watsonManufacturing = require('../../assets/img/manufacturing.png');
const watsonDrone = require('../../assets/img/drone.png');
const watsonRoboticArm = require('../../assets/img/roboticarm.png');

class Inspectr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHome: false,
            isInspectr: true
        };

    }

    render() {
        return (
            <div className="inspectr-container">
                <div className="inspectr-header">
                <Header/>
                </div>

                <div className="inspectr-hero">
                    <div className="inspectr-about">
                        <div className="header">About IoTVision</div>
                        <div className="text"> Built by the <b><i>Edge & AI & Connected Operations team of IBM Canada</i></b>, <b>IoTVision</b> is a proven visual recognition platform that can be used to <i><b>design, build, deploy, maintain  
                        Edge AI focused solution </b></i>at any level of AI operation maturity, even across levels.<br /><br />
                        It is an AI solution development framework for building and running <b>custom AI Solutions at scale</b>.
                        Proven with customer engagements, it can comprehend, analyze, and provide
                        insights of the content within images using custom built AI models and pipielines </div>
                    </div>

                    <div id="mybutton">
                        <button className="feedback">Contact</button>
                    </div>

                    <div className="inspectr-solutions">
                        <div className="header">Applications </div>
                        <div className="solution-wrapper">
                        
                            {/*<div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonTrain}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Rail Safety</h3>  
                                    <p>In order to ensure safety, the ability to detect key component that holds train cars together where users get alerts when it is missing.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Rail Safety</div>
                            </div>*/}

                        <Link target="_blank" to="https://inspectr-frontend.13dem16r2xas.us-south.codeengine.appdomain.cloud/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonTrain}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Autonomous Safety & Inspection @Edge</h3>  
                                    <p>In order to ensure safety, the ability to detect key components for like Train and along the Critical Path together where users get alerts when it is missing, processing on Edge using fixed camera system and robot, running on Edge or mix with Edge and DC/Clouds.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Autonomous Inspection @Edge</div>
                            </div>
                        </Link>

                        <Link target="_blank" to="https://vehicle-inspectr.qurrrrnzgme.us-south.codeengine.appdomain.cloud/#/licenseplate">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonCar}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>License Plate Detection</h3>  
                                    <p>Using cameras to take pictures of licenses plates and extrapolate the plate numbers and details.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">License Plate Detection</div>
                            </div>
                        </Link>

                        <Link target="_blank" to="https://vehicle-inspectr.qurrrrnzgme.us-south.codeengine.appdomain.cloud/#/tire">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonTruck}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Axle Detection</h3>  
                                    <p>Inspect and count the number of axels and tires on vehicles.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Axle Detection</div>
                            </div>
                        </Link>
 

                        {/*<Link target="_blank" to="http://form-inspectr.mybluemix.net/#/">*/}
                        <Link target="_blank" to="https://demo-iotcanada.s3.ca-tor.cloud-object-storage.appdomain.cloud/iotcanada-demo-documentinsight.mp4">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonForm}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Document Analyzer</h3>  
                                    <p>Smart Pages helps you analyze documents identifying checkboxes, hand writing and strikethroughs for cognitive contract management.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Document Analyzer</div>
                            </div>
                       </Link>

                       <Link target="_blank" to="https://demo-iotcanada.s3.ca-tor.cloud-object-storage.appdomain.cloud/iotcanada-demo-roboticarm.mp4">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonRoboticArm}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Robotic Automation with Computer Vision</h3>  
                                    <p>Using both computer vision and robotic, automate the manufacturing process with machine learning to improve process quality.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Robotic Automation</div>
                            </div>
                        </Link>


                        {/*<Link target="_blank" to="https://gc-dashboard.mybluemix.net/">*/}
                        <Link target="_blank" to="https://demo-iotcanada.s3.ca-tor.cloud-object-storage.appdomain.cloud/iotcanada-demo-drone.mp4">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonDrone}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Drone Inspection</h3>  
                                    <p>Using visual recognition with Drone, automate inspections to improve process and worker's safety.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Drone Inspection</div>
                            </div>
                        </Link>


                        <Link target="_blank" to="https://perdue-chickens-demo.qurrrrnzgme.us-south.codeengine.appdomain.cloud/">
                            <div className="tracer-solution-container"> 
                                <div className="box">
                                    <img className="tracer-image" src={watsonManufacturing}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Process Monitoring</h3>  
                                    <p>Using videos in manufacturing and operational process to identify faults and defaults, and improve streamline processes.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Process Monitoring</div>
                            </div>
                        </Link>


                        {/*<Link target="_blank" to="https://inside-edge.mybluemix.net/">
                            <div className="tracer-solution-container"> 
                                <div className="box">
                                    <img className="tracer-image" src={watsonTraffic}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Traffic Monitoring</h3>  
                                    <p>Using video surveillance cameras to track movement of vehicles and pedestrians.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Traffic Monitoring</div>
                            </div>
                        </Link>*/}

                        <Link target="_blank" to="https://pystream-frontend-demo.qurrrrnzgme.us-south.codeengine.appdomain.cloud/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonSpace}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Space Utilization</h3>  
                                    <p>Using video surveillance cameras to track the overall occupancy and utilization of the location and space.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Space Utilization</div>
                            </div>
                        </Link>

                        <Link target="_blank" to="https://bidadvisor-demo.qurrrrnzgme.us-south.codeengine.appdomain.cloud/?">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonPumps}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Bid Advisor</h3>  
                                    <p>Using visual recognition to track different objects and extracts their corresponding tags.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Bid Advisor</div>
                            </div>
                        </Link>


                        {/*<Link target="_blank" to="https://gc-dashboard.mybluemix.net/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonGeology}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Geology Manuscript Reader</h3>  
                                    <p>Using visual recognition to read geological manuscripts.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Geology Manuscript Reader</div>
                            </div>
                        </Link>*/}



                        {/*<Link target="_blank" to="http://sound-analyzer.mybluemix.net/#/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonAudio}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Sound Analyzer</h3>  
                                    <p>Understanding anomalies in the sound of any engines to alert, predict and prescribe actions.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Sound Analyzer</div>
                            </div>
                    </Link>*/}


                        <Link target="_blank" to="https://forecasting-demo.qurrrrnzgme.us-south.codeengine.appdomain.cloud/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonEnergy}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Demand and Price Forecasting</h3>  
                                    <p>Forecsting the demand for supply, demand, energy prices, taking action from insights.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Demand and Price Forecasting</div>
                            </div>
                        </Link>


                        {/*<Link target="_blank" to="https://retailstore-inspectr-app.mybluemix.net/#/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonRetail}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Retail Classification</h3>  
                                    <p> Using VR to classify your items by gender, type style and other attributes.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Retail Classification</div>
                            </div>
                        </Link>*/}

                        {/*<Link target="_blank" to="https://paymod-dashboard.mybluemix.net/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonStamp}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Payroll Management</h3>  
                                    <p> Gather insights about company payment scheduling, actions, and times.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Payroll Management</div>
                            </div>
                        </Link>*/}  

                        {/*<Link target="_blank" to="https://aed-poc.mybluemix.net/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonAed}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>AED Management</h3>  
                                    <p> Using sensor data to track the nearest available AED to help save lives.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">AED Management</div>
                            </div>
                        </Link>*/}                      

                        {/*<Link target="_blank" to="http://vehicle-inspectr-app.mybluemix.net/#/traffic">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonHighway}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Highway Monitor</h3>  
                                    <p>Using video surveillance cameras to identify types of vehicles on the roads.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Highway Monitor</div>
                            </div>
                    </Link>*/}

                    {/*
                    <Link target="_blank" to="http://vehicle-inspectr-app.mybluemix.net/#/shms">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonSound}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Weather & Vibration</h3>  
                                    <p>Structural health and weather sensors to give identify conditions that may affect infrastructure and/or cities.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Vibration and Weather Detection</div>
                            </div>
                    </Link>
                */}

                    {/*<Link target="_blank" to="https://atco-poc.mybluemix.net/">
                            <div className="tracer-solution-container"> 
                                <div className="box">  
                                    <img className="tracer-image" src={watsonEnergy}/>  
                                    <span className="solution-description fade-solution-description">  
                                    <h3>Energy Management</h3>  
                                    <p> Using sensor data to help track, manage, and gather insights on how to more efficiently use building energy.</p>  
                                    </span>  
                                </div>
                                <div className="solution-title">Energy Management</div>
                            </div>
                    </Link>*/}

                        </div>
                    </div>

                    <Footer />

                </div>
            </div>
        );
    }
}

export default Inspectr;



// WEBPACK FOOTER //
// src/components/inspectr/Inspectr.js